export default function CurrentDateTime() {
  const sundte = new window.Date();
  let yeardte = sundte.getFullYear();
  let monthdte = sundte.getMonth();
  let dtedte = sundte.getDate();
  let daydte = sundte.getDay();
  let today;
  let sunmonth;
  let daysun;
  let i;
  switch (daydte) {
    case 0:
      today = "يکشنبه";
      break;
    case 1:
      today = "دوشنبه";
      break;
    case 2:
      today = "سه شنبه";
      break;
    case 3:
      today = "چهارشنبه";
      break;
    case 4:
      today = "پنجشنبه";
      break;
    case 5:
      today = "جمعه";
      break;
    case 6:
      today = "شنبه";
      break;
    default:
      break;
  }
  switch (monthdte) {
    case 0:
      if (dtedte <= 20) {
        sunmonth = "دي";
        daysun = dtedte + 10;
      } else {
        sunmonth = "بهمن";
        daysun = dtedte - 20;
      }
      break;
    case 1:
      if (dtedte <= 19) {
        sunmonth = "بهمن";
        daysun = dtedte + 11;
      } else {
        sunmonth = "اسفند";
        daysun = dtedte - 19;
      }
      break;
    case 2:
      if ((yeardte - 621) % 4 === 0) i = 10;
      else i = 9;
      if (dtedte <= 20) {
        sunmonth = "اسفند";
        daysun = dtedte + i;
      } else {
        sunmonth = "فروردين";
        daysun = dtedte - 20;
      }
      break;
    case 3:
      if (dtedte <= 20) {
        sunmonth = "فروردين";
        daysun = dtedte + 11;
      } else {
        sunmonth = "ارديبهشت";
        daysun = dtedte - 20;
      }
      break;
    case 4:
      if (dtedte <= 21) {
        sunmonth = "ارديبهشت";
        daysun = dtedte + 10;
      } else {
        sunmonth = "خرداد";
        daysun = dtedte - 21;
      }

      break;
    case 5:
      if (dtedte <= 21) {
        sunmonth = "خرداد";
        daysun = dtedte + 10;
      } else {
        sunmonth = "تير";
        daysun = dtedte - 21;
      }
      break;
    case 6:
      if (dtedte <= 22) {
        sunmonth = "تير";
        daysun = dtedte + 9;
      } else {
        sunmonth = "مرداد";
        daysun = dtedte - 22;
      }
      break;
    case 7:
      if (dtedte <= 22) {
        sunmonth = "مرداد";
        daysun = dtedte + 9;
      } else {
        sunmonth = "شهريور";
        daysun = dtedte - 22;
      }
      break;
    case 8:
      if (dtedte <= 22) {
        sunmonth = "شهريور";
        daysun = dtedte + 9;
      } else {
        sunmonth = "مهر";
        daysun = dtedte + 22;
      }
      break;
    case 9:
      if (dtedte <= 22) {
        sunmonth = "مهر";
        daysun = dtedte + 8;
      } else {
        sunmonth = "آبان";
        daysun = dtedte - 22;
      }
      break;
    case 10:
      if (dtedte <= 21) {
        sunmonth = "آبان";
        daysun = dtedte + 9;
      } else {
        sunmonth = "آذر";
        daysun = dtedte - 21;
      }

      break;
    case 11:
      if (dtedte <= 19) {
        sunmonth = "آذر";
        daysun = dtedte + 9;
      } else {
        sunmonth = "دي";
        daysun = dtedte + 21;
      }
      break;
    default:
      break;
  }
  return `امروز ${today} ${daysun} ${sunmonth}`;
}
